import { render, staticRenderFns } from "./SettingsCGU.vue?vue&type=template&id=50f08924&"
import script from "./SettingsCGU.vue?vue&type=script&lang=js&"
export * from "./SettingsCGU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports